export const DEVNET_NODE_URL = "https://fullnode.devnet.aptoslabs.com/v1";
export const TESTNET_NODE_URL = "https://fullnode.testnet.aptoslabs.com/v1";
export const MAINNET_NODE_URL = "https://fullnode.mainnet.aptoslabs.com/v1";
export const SWAP_ADDRESS_MAINNET = "0x6ee5ff12d9af89de4cb9f127bc4c484d26acda56c03536b5e3792eac94da0a36";
export const SWAP_ADDRESS_TESTNET = "0x5d1b1f3198e468b4f093a92fbd091209b0b045bcdd35ea6fbe82842e2a11740a";//"0x8f6e67afd83fcb89f6f9ea703493711b8fa84b3f6f5cbd2832133416f3ed2dd7";
export const APT_TOKEN_ADDRESS = "0x1::aptos_coin::AptosCoin";
export const APTOSLABS_URL = "https://explorer.aptoslabs.com";
export const networks = ["Mainnet", "Testnet"];

export const localStorageKeyNetwork = "network";

export const denominator = 10000;